import { useEffect, useState } from "react";
import { SongCard } from "./SongCard";
import { TrackData } from "../types/Types";
import { UpvotedTracksService } from "../services/UpvotedSongsService";
import "../styles/HorizontalTrackFeeds.css";
import "../App.css";

export const UpvotedTracks = () => {
  const [tracks, setTracks] = useState<TrackData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUpvoted = async () => {
      const data = await UpvotedTracksService.getUpvotedTracks();
      setTracks(data);
      setLoading(false);
    };
    fetchUpvoted();
  }, []);

  if (loading) return null;

  return (
    <section className="upvoted-tracks-section">
      <div className="recently-added-feed-header-container">
        <h2 className="scrollable-feed-header">Upvoted Tracks</h2>
      </div>

      <div className="song-card-scroll-container">
        {tracks.map((track) => (
          <SongCard key={track.id} track={track} />
        ))}
      </div>
    </section>
  );
};
